var initialState = [];
import MerchantConstants from '../../constants/MerchantConstants';

export default function types(state = initialState, action) {
  switch (action.type) {
    case MerchantConstants.MERCHANT_GET_TYPES:
      return action.payload;
    default:
      break;
  }
  return state;
}



/** WEBPACK FOOTER **
 ** ./src/reducers/data/types.js
 **/